export default {
    "zoom-in": {
        origin: { scale: 0.8 },
        destination: { scale: 1.2 },
    },
    "zoom-in-fade-in": {
        origin: { scale: 0.8, opacity: 0 },
        destination: { scale: 1.2, opacity: 1 },
    },
};
